export const getPath = (href: string = '') => {
    const { pathname, search, hash } = new URL(href);

    return `${pathname}${search}${hash}`;
};
